export const blockIconsMapsNearMe = (
	<span className='material-symbols-outlined'>near_me</span>
);
